var _defs, _path, _path2, _path3, _line;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgDataSnag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.01 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffc000;stroke:#ffc000;}.cls-1,.cls-2,.cls-3{stroke-linecap:round;stroke-linejoin:round;}.cls-2,.cls-3{fill:none;}.cls-2{stroke:#39f;}.cls-3{stroke:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.84,11.5a1,1,0,0,0-1.29-.39,1,1,0,0,0-.39.39l-5,9.64a.9.9,0,0,0,0,.91.94.94,0,0,0,.8.45H17.06a.94.94,0,0,0,.8-.45.9.9,0,0,0,0-.91Z",
    transform: "translate(-0.5 -1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.5,13.91A4.32,4.32,0,0,0,23,9.86a4.71,4.71,0,0,0-4.78-4.64h-.17A6.71,6.71,0,0,0,12,1.5,6.61,6.61,0,0,0,5.32,7.61a3.56,3.56,0,0,0-4.24,2.71A3.27,3.27,0,0,0,1,11,3.19,3.19,0,0,0,3.5,14.3",
    transform: "translate(-0.5 -1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12,19.5a.25.25,0,1,0,.25.25A.25.25,0,0,0,12,19.5h0",
    transform: "translate(-0.5 -1)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 11.5,
    y1: 16.5,
    x2: 11.5,
    y2: 13.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataSnag);
export default __webpack_public_path__ + "static/media/DataSnag.271c16ba6010c031bb581f0d38e7a720.svg";
export { ForwardRef as ReactComponent };